import { useParams } from "react-router-dom";
import {
  AnnualBudgetPlanDetailsForm,
  AnnualBudgetPlanDetailsHeader,
  AnnualBudgetPlanDetailsTable,
  //   ProcurementDetailsTable,
  //   ProcurementDetailsForm,
} from "./components";
import { useAnnualProcurementPlan } from "@hooks/procurements/annualProcurementPlan/useAnnualProcurementPlan";

export default function AnnualBudgetPlanDetails() {
  const { id } = useParams();
  const { annualProcurementPlanState } = useAnnualProcurementPlan(id as string);

  const { getSingleData } = annualProcurementPlanState;

  //!!! used any

  return (
    <div className="d-grid gap-10 p-10">
      <AnnualBudgetPlanDetailsHeader
        data={id ? (getSingleData as any) : null}
      />
      <AnnualBudgetPlanDetailsForm
        procurement={id ? (getSingleData as any) : null}
        id={id as string}
      />
      <AnnualBudgetPlanDetailsTable id={id as string} />
    </div>
  );
}
